module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-trust-5a7948f49b87d5504b31ae498d7a39a7.svg";